var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading_mask"},[_c('div',{staticClass:"reverse-cont"},[_c('div',{staticClass:"reverse-spinner"}),_c('div',{staticClass:"timebox"},[_vm._v(" "+_vm._s(_vm.t)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }